import * as angular from 'angular';
import AuthService from './auth.service';
import AUTH_CONSTANT from './auth.constant';

export default angular
  .module('auth', [])
  .service('AuthService', AuthService)
  .value('AUTH_CONSTANT', AUTH_CONSTANT)
  .name;



// WEBPACK FOOTER //
// ./src/app/core/auth/auth.module.js